export const getStyles = () => ({
	companyLogo: {
		picture: "tw-flex tw-justify-center",
		image: "tw-max-w-[140px] lg:tw-max-w-[160px] tw-rounded-lg",
	},
	serviceFlag: {
		wrapper: "",
		flag: "tw-ml-2 tw-absolute tw-top-1 lg:tw-top-[45%] tw-bg-[#616096] tw-w-[28px] tw-h-[28px] tw-text-white tw-font-extrabold tw-flex tw-justify-center tw-items-center tw-shadow-lightShadow tw-rounded-full",
		number: "tw-m-0 tw-text-white tw-font-medium tw-text-sm",
		text: "[clip-path:polygon(100%_0,calc(100%-10px)_100%,0_100%,0_0)] tw-bg-[#359492] tw-top-1 tw-w-max tw-absolute tw-text-white tw-h-[28px] tw-text-base tw-flex tw-justify-center tw-items-center tw-my-0 tw-py-0 tw-pl-2 tw-pr-5 tw-font-medium tw-text-sm tw-shadow-lightShadow tw-ml-10 lg:tw-ml-0",
	},
	benefitsList: {
		wrapper: "tw-flex tw-gap-6 tw-px-0",
		list: "tw-flext-1 tw-w-full tw-mb-0 tw-p-0",
		listItem:
			"tw-leading-7 tw-w-full tw-text-base tw-text-[#000a25] tw-pl-6 tw-mb-2 tw-bg-[url(/public/react-images/common/favyCheck.svg)] [background-position:left_top_7px] tw-bg-no-repeat",
	},
	visitLink: {
		wrapper:
			"tw-my-2 tw-mx-0 tw-flex tw-w-[165px] tw-h-[40px] tw-bg-[#359492] tw-rounded-full tw-shadow-lightShadow tw-cursor-pointer tw-transition hover:tw-bg-[#3d9f9e] hover:tw-shadow-[0px_2px_4px_0px_#c0c0c0] lg:tw-w-full",
		contentWrapper:
			"tw-font-[Montserrat] tw-leading-6 tw-px-2 tw-text-white tw-w-full tw-flex tw-items-center tw-justify-center tw-text-center tw-font-bold tw-text-lg lg:tw-text-xl",
	},
	rating: {
		wrapper: "tw-flex tw-flex-col tw-gap-1 tw-justify-center tw-items-center",
		score: "tw-font-semibold tw-text-[#747481] tw-text-base",
		stars:
			"tw-flex tw-justify-between lg:tw-justify-center tw-flex-row tw-items-center tw-w-fit",
		starColor: "tw-text-[#faaf00]",
		starSize: "tw-text-2xl",
	},
	trustpilotReview: {
		container:
			"tw-flex tw-flex-col tw-w-fit tw-text-center tw-min-w-[118px] tw-max-w-[120px]",
		reviewCount:
			"tw-text-[#232227] tw-font-semibold tw-text-[13px] tw-leading-[1.5]",
		reviewCountNumber: "tw-font-bold [font-family:Graphik_Web]",
		reviewCountText: "tw-font-normal",
		ratingContainer: "tw-my-1 tw-flex tw-gap-[3px] tw-justify-center",
		starBase:
			"tw-relative tw-rounded-[3px] tw-w-[18px] tw-h-[18px] tw-flex tw-items-center tw-justify-center tw-text-white tw-text-xs",
		ratingCountWrapper: "tw-w-full tw-flex tw-items-end tw-justify-evenly",
		ratingCount: "tw-font-bold tw-text-base tw-text-[#232227]",
		ratingCountText: "tw-text-base tw-text-[#232227]",
		trustPilotLogo: "tw-h-4 tw-w-auto",
	},
});
